import React, { ReactNode } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from './ui/tooltip';
import { cn } from '@/utils/utils';
import { useThrottle } from '@/hooks/useThrottle';
import { InfoIcon } from 'lucide-react';

export type InfoCircleProps = {
  details: ReactNode;
  id?: string;
};

const InfoCircle: React.FC<InfoCircleProps> = ({ details, id }) => {
  const [open, setOpen] = React.useState(false);
  const throttledOpen = useThrottle(open, 750);

  return (
    <Tooltip open={throttledOpen} delayDuration={500}>
      <TooltipContent className={cn('max-w-md normal-case')}>
        {details}
      </TooltipContent>
      <TooltipTrigger
        asChild
        onMouseEnter={() => {
          setOpen(true);
        }}
        onMouseLeave={() => {
          setOpen(false);
        }}
        onFocus={() => {
          setOpen(true);
        }}
        onBlur={() => {
          setOpen(false);
        }}
      >
        <div className="inline-flex" id={id}>
          <InfoIcon className="size-3 stroke-foreground self-center shrink-0" />
        </div>
      </TooltipTrigger>
    </Tooltip>
  );
};

export default InfoCircle;
